var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailWhat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95,
    height: 77.5,
    viewBox: "0 0 95 77.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 95,
    height: 77.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 95,
    height: 77,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 42.864,
    height: 41,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(-45.034 -135.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_3_1",
    "data-name": "Component 3 \\u2013 1",
    transform: "translate(45.034 135.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 95,
    height: 77,
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 75.311,
    height: 57.025,
    rx: 8,
    transform: "translate(9.501 7.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 75.311,
    height: 57.025,
    rx: 8,
    transform: "translate(9.501 7.5)",
    fill: "none",
    stroke: "#838383",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M46.05,63.12s6.17,15.352,9.274,13.765S62.366,63.12,62.366,63.12",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M46.05,63.12s6.17,15.352,9.274,13.765S62.366,63.12,62.366,63.12",
    fill: "none",
    stroke: "#838383",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Component_2_1",
    "data-name": "Component 2 \\u2013 1",
    transform: "translate(71.102 151.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M41.969,1.92,26.3,13.251l-2.572,1.863a3.857,3.857,0,0,1-4.585,0l-2.571-1.863L.876,1.939A4.634,4.634,0,0,1,4.659,0H38.2a4.661,4.661,0,0,1,3.765,1.92",
    fill: "#6279c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M.876,1.938,16.568,13.25,1.361,28.458A4.66,4.66,0,0,1,0,25.159V4.659A4.607,4.607,0,0,1,.876,1.938",
    fill: "#3e51a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M42.864,4.659v20.5a4.662,4.662,0,0,1-1.36,3.3L26.3,13.25,41.969,1.919a4.632,4.632,0,0,1,.895,2.74",
    fill: "#3e51a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M27.955,33.545c-1.238,0-1.864-.932-1.864-2.795a4.715,4.715,0,1,0-1.135,3.013,3.324,3.324,0,0,0,3,1.646c3.727,0,3.727-3.508,3.727-4.659a10.248,10.248,0,1,0-3.123,7.367.935.935,0,1,0-1.305-1.339,8.389,8.389,0,1,1,2.564-6.028c0,2.089-.469,2.795-1.863,2.795m-6.523,0a2.795,2.795,0,1,1,2.8-2.795,2.8,2.8,0,0,1-2.8,2.795",
    fill: "#d51a66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M26.3,13.25l-2.572,1.865a3.862,3.862,0,0,1-4.584,0L16.568,13.25,1.36,28.457a4.665,4.665,0,0,0,3.3,1.362H9.365a12.1,12.1,0,0,1,24.132,0h4.708a4.661,4.661,0,0,0,3.3-1.362Z",
    fill: "#3e38a1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhat);
export default __webpack_public_path__ + "static/media/email_What.d95396327ec57a077b806d6b1f50a19e.svg";
export { ForwardRef as ReactComponent };